import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/http'

import i18n from './i18n'
import 'babel-polyfill'
import jsBridge from './plugins/jsBridge'

Vue.use(jsBridge);
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
